var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('SectionName',{attrs:{"name":"HINNAD"}}),_vm._l((_vm.prices),function(price){return _c('BasicTable',{key:price.class,attrs:{"type":"price","name":price.class,"items":price.data,"table-config":_vm.tableConfig}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }